import { render } from "./SbmDashboard.vue?vue&type=template&id=70865556&scoped=true"
import script from "./SbmDashboard.vue?vue&type=script&lang=js"
export * from "./SbmDashboard.vue?vue&type=script&lang=js"

import "./SbmDashboard.vue?vue&type=style&index=0&id=70865556&lang=css"
import "./SbmDashboard.vue?vue&type=style&index=1&id=70865556&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70865556"]])

export default __exports__